<template>
  <TWModal
    :title="$t('envelope.noFieldsWarning.title')"
    :loading="false"
    :show="show"
    @close="close"
    :allow-outside-click-to-close="false"
  >
    <template v-slot:content>
      <p>{{ $t('envelope.noFieldsWarning.message') }}</p>
    </template>
    <template v-slot:controls>
      <div class="w-full flex flex-col sm:flex-row justify-between gap-base">
        <BaseButton
          @click.native="send"
          variant="secondary"
          data-ec="confirm_no_fields_before_send_modal"
          data-et="send_without_fields_button"
        >
          {{ $t('envelope.noFieldsWarning.sendWithoutFields') }}
        </BaseButton>
        <div class="flex flex-col-reverse sm:flex-row gap-base">
          <BaseButton
            @click.native="close"
            variant="invisible"
            data-ec="confirm_no_fields_before_send_modal"
            data-et="cancel_button"
          >
            {{ $t('functional.cancel') }}
          </BaseButton>
          <BaseButton
            @click.native="addFields"
            data-ec="confirm_no_fields_before_send_modal"
            data-et="go_to_add_fields_button"
          >
            {{ $t('envelope.noFieldsWarning.addFields') }}
          </BaseButton>
        </div>
      </div>
    </template>
  </TWModal>
</template>

<script>
import TWModal from '@/components/tailwind/Modal.vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';

export default {
  name: 'ConfirmNoFieldsBeforeSendModal',
  components: { TWModal, BaseButton },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    addFields() {
      this.$emit('addFields');
      this.close();
    },
    send() {
      this.$emit('send');
      this.close();
    },
  },
};
</script>

